import { Input } from "../ui/input";
import { Label } from "../ui/label";

export const CalcInputs = ({ fields, values, onChange }) => (
  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
    {fields.map((field) => (
      <div key={field.key} className="space-y-1.5">
        <Label htmlFor={field.key} className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          {field.label}
        </Label>
        <div className="relative">
          {field.prefix && (
            <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground">
              {field.prefix}
            </span>
          )}
          <Input
            id={field.key}
            data-testid={`input-${field.key}`}
            type="number"
            inputMode="decimal"
            value={values[field.key]}
            onChange={(e) => onChange(field.key, e.target.value)}
            className={`tabular h-12 ${field.prefix ? "pl-7" : ""} ${field.suffix ? "pr-9" : ""}`}
          />
          {field.suffix && (
            <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground">
              {field.suffix}
            </span>
          )}
        </div>
        {field.help && <p className="text-xs text-muted-foreground">{field.help}</p>}
      </div>
    ))}
  </div>
);
